import DataTable from "react-data-table-component";
import React from "react";
import { Button, Col, ModalHeader, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  setBalanceDetailsLimit,
  setBalanceDetailsPage,
} from "../../../redux/actions/reports/reportsAction";

import { useEffect } from "react";
import { ConfirmCloseStaffSession } from "../../modals/confirmCloseStaffSession";
import { setConfirmCloseStaffSessionModalOpen } from "../../../redux/actions/staffSession/staffSessionAction";
import { confirmCloseStaffSession } from "../../../redux/actions/api/apiAction";
import { cashesList } from "../../appointment/utils";

const VerifyAndInfoStaffSessionsDetails = () => {
  const { currentStaffSessionsToVerify, confirmCloseStaffSessionModalOpen, confirmCloseStaffSessionOpenedID } = useSelector((state) => state.staffSession);
  
  const dispatch = useDispatch();

  const columns = [
    {
      name: "Session ID",
      selector: (row) => row?.id || "N/A",
      sortable: true,
    },
    {
      name: "Cash",
      selector: (row) => {
        let cashName = "";
        cashesList.map(c => {
          if (c.id == row.cash) {
            cashName = c.label; 
          }
        });
        return cashName;
      },
      sortable: true,
    },
    {
      name: "Created By",
      selector: (row) => row?.createdBy?.name || "N/A",
      sortable: true,
    },
    {
      name: "Cash At End Amount",
      selector: (row) => row?.endCashOnSiteAmount,
      sortable: true,
    },
    {
      name: "Closed By",
      selector: (row) => row?.sessionClosedBy?.name || "N/A",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <Button
          className="settle-btn"
          onClick={() => {
            dispatch(setConfirmCloseStaffSessionModalOpen(true, row.id));
          }}
        >
          Confirm
        </Button>
      ),
      sortable: true,
    },
  ];

  const confirmCloseStaffSessionHandler = (values) => {

    dispatch(confirmCloseStaffSession({
      staffSessionId: confirmCloseStaffSessionOpenedID,
      cashOnSiteConfirmedAmount: values.cashOnSiteConfirmed
    }));
  };

  return (
    <Row style={{padding: "10px"}}>
      <ModalHeader className="w-100" toggle={()=>{}}>Sessions To Be Verified Details</ModalHeader>
      <Col xs={12} className="mt-4">
        {currentStaffSessionsToVerify && (
          <DataTable
            responsive
            className="dark-blue-table"
            columns={columns}
            data={currentStaffSessionsToVerify}
            pagination
            paginationServer
            paginationTotalRows={currentStaffSessionsToVerify?.length}
            onChangeRowsPerPage={(newLimit) =>
              dispatch(setBalanceDetailsLimit(newLimit))
            }
            onChangePage={(newPage) => dispatch(setBalanceDetailsPage(newPage))}
          />
        )}
        {
          confirmCloseStaffSessionModalOpen &&
          <ConfirmCloseStaffSession handleSubmit={confirmCloseStaffSessionHandler}/>
        }
      </Col>
    </Row>
  );
};

export default VerifyAndInfoStaffSessionsDetails;